import React, { useState } from 'react'

import { Button } from '@resurs/midas-react'
import PropTypes from 'prop-types'
import { getText } from '../../../../../internal/TextLabels'

const SigningModalCancel = ({ onClose }) => {
  const [displayConfirmation, setDisplayConfirmation] = useState(false)

  return displayConfirmation ? (
    <div style={{ margin: 'auto' }}>
      <hr />
      <p style={{ textAlign: 'left', maxWidth: '500px', lineHeight: '1.25' }}>
        {getText('payApply.signing.abortConfirmation')}
      </p>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Button
          id="confirm-cancel-btn-yes"
          type="normal"
          badgeLabel="danger"
          size="small"
          onClick={onClose}
        >
          {getText('payApply.signing.abortConfirmationYes')}
        </Button>
        <Button
          id="confirm-cancel-btn-no"
          type="primary"
          size="small"
          onClick={() => setDisplayConfirmation(false)}
        >
          {getText('payApply.signing.abortConfirmationNo')}
        </Button>
      </div>
    </div>
  ) : (
    <Button
      id="digital-cancel-btn"
      type="normal"
      badgeLabel="danger"
      size="small"
      onClick={() => setDisplayConfirmation(true)}
    >
      {getText('default.cancel')}
    </Button>
  )
}

SigningModalCancel.propTypes = {
  onClose: PropTypes.func.isRequired,
}

export default SigningModalCancel
